<template>
  <div class="flex h-full items-center justify-center">
    <div class="text-center">
      <div class="mb-lg text-[54px] leading-[59px]">
        <span
          v-for="(char, index) in code"
          :key="index"
          class="inline-block w-[54px]"
        > {{ char }} </span>
      </div>
      <h4 class="mb-xs typography-body-1-bold">
        {{ $t('notFound.title') }}
      </h4>
      <p class="mb-md typography-body-2-regular">
        {{ $t('notFound.text') }}
      </p>
      <OrButtonV3 @click="$router.back">
        {{ $t('notFound.goBack') }}
      </OrButtonV3>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { OrButtonV3 } from '@onereach/ui-components';

export default defineComponent({
  name: 'NotFound',
  components: {
    OrButtonV3,
  },
  data() {
    return {
      code: '404',
    };
  },
});
</script>
